<script setup lang="ts">
import { tracking } from '~/services/tracking.client'

import {computed} from 'vue'

interface BannerSlot {
    id: string
    label: string
    web: string
    mobile: string
    url: string
    fit: string
}

interface BannerInterface {
    bannerHeight: string
    bannerHeightMobile: string
    bannerGap:string;
    bannerGapMobile:string;
    bannerDirection:string;
    slots: BannerSlot[]
}

const props = defineProps<{
    config: BannerInterface,
    class?:string,
    id?:string|number
}>()

const main = computed(() =>
    props.config.slots?.filter((i) => i.id.includes('main-') && (i.web || i.mobile)) || []
)


const promotionRoot = ref<HTMLElement>()
let promotionObserver: IntersectionObserver | undefined
onMounted(() => {
    if (!promotionRoot.value || !('IntersectionObserver' in window)) return
    const seen = new Set<string>()
    promotionObserver = new IntersectionObserver(entries => {
        for (const entry of entries) {
            const target = entry.target as HTMLElement
            const id = target.dataset.promotionId
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5 && id && !seen.has(id)) {
                seen.add(id)
                tracking.promotion('view_promotion', id, target.dataset.promotionName || id)
            }
        }
    }, { threshold: 0.5 })
    promotionRoot.value.querySelectorAll('[data-promotion-id]').forEach(element => promotionObserver!.observe(element))
})
onBeforeUnmount(() => promotionObserver?.disconnect())
</script>

<template>
    <div
      role="banner" ref="promotionRoot"
            class="banner2"
            :class="props?.class || ''"
            :style="{
      '--banner-height': config.bannerHeight,
      '--banner-height-mobile': config.bannerHeightMobile,
      '--banner-gap': config.bannerGap,
      '--banner-gap-mobile': config.bannerGapMobile,
      '--banner-flex-direction':config.bannerDirection
    }"
    >
      <NuxtLinkLocale
          v-for="(item, index) in main"
          :key="item.id"
          :to="item.url || '/'" :data-promotion-id="`${props.id || 'banner'}:${item.id}`" :data-promotion-name="item.label" @click="tracking.promotion('select_promotion', `${props.id || 'banner'}:${item.id}`, item.label)"
          class="banner2__slide"
      >
        <picture>
          <source
              v-if="item.mobile"
              :srcset="item.mobile"
              media="(max-width: 992px)"
          >
          <source
              v-if="item.web"
              :srcset="item.web"
              media="(min-width: 993px)"
          >
          <img
              class="banner2__img"
              :src="item.web || item.mobile"
              :alt="item.label"
              :style="{ objectFit: item.fit || 'contain' }"
              :loading="index === 0 ? 'eager' : 'lazy'"
              :fetchpriority="index === 0 ? 'high' : undefined"
              decoding="async"
          >
        </picture>
      </NuxtLinkLocale>
    </div>
</template>

<style lang="scss" scoped>
.banner2 {
    display: flex;
    flex-direction: var(--banner-flex-direction);
    gap: var(--banner-gap);
  @media (max-width: 992px) {
    flex-direction: column !important;
    gap: var(--banner-gap-mobile);
  }
  .banner2__slide {
    width: 100%;
    height: var(--banner-height);
    @media (max-width: 992px) {
      height: var(--banner-height-mobile);
    }
  }
  .banner2__img {
    width: 100%;
    height: 100%;

  }
}
</style>




